<template>
  <nuttrema-layout-three-vertical class="is-in-mobile-ready-layout">

    <template v-if="token">

      <participant-standard-header
         slot="top"
         v-if="!loading"
        :meta="meta"
        :showEdit="false"
        :showOnMobileAndTablet="showOnMobileAndTablet">
      </participant-standard-header>

      <template slot="middle">
        <nuttrema-loader v-if="loading"></nuttrema-loader>

        <nuttrema-empty-result v-else-if="error" icon="far fa-qrcode">
          <template slot="text">
            <h1>{{ $t('label.invalid_token') }}</h1>
            <h4>{{ $t('label.missing_token_help') }}</h4>
          </template>
        </nuttrema-empty-result>

        <nuttrema-calivi
           v-else
          :scheduleID="scheduleID"
          :class="[`is-${gender}`]"
          :scheduleDate="scheduleDate"
          :ScheduledDates="PublicScheduledDates"
          :ScheduleDetails="PublicScheduleDetails"
          :ScheduledDateSchedules="PublicScheduledDateSchedules"
          @changeScheduleDate="onChangeScheduleDate"
          @changeScheduleID="onChangeScheduleID">
        </nuttrema-calivi>
      </template>

    </template>

    <template v-else slot="middle">
      <nuttrema-empty-result icon="far fa-qrcode">
        <template slot="text">
          <h1>{{ $t('label.missing_token') }}</h1>
          <h4>{{ $t('label.missing_token_help') }}</h4>
        </template>
      </nuttrema-empty-result>
    </template>


  </nuttrema-layout-three-vertical>
</template>

<script>
import moment from 'moment';
import { get } from 'lodash';

import PageProps from 'components/mixins/page-props';
import ResponsiveMonitor from 'components/mixins/responsive-monitor';

import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';
import NuttremaCalivi from 'components/ui/schedules/nuttrema-calivi';

import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';

export default {
  name: 'page-participant-public-schedules',
  mixins: [
    PageProps,
    ResponsiveMonitor,
  ],
  props: {
    token: {
      required: true,
      default: null,
    },
    schedule_id: {
      required: false,
      default: null,
    },
    schedule_date: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaCalivi,
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
  data() {
    return {
      scheduleID: null,
      scheduleDate: null,
      childScheduleID: null,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    PublicScheduledDateSchedules() {
      return this.$store.getters.PublicScheduledDateSchedules;
    },
    PublicScheduledDates() {
      return this.$store.getters.PublicScheduledDates;
    },
    PublicScheduleDetails() {
      return this.$store.getters.PublicScheduleDetails(this.scheduleID);
    },
    loading() {
      return this.PublicScheduledDateSchedules.fetching || this.PublicScheduledDates.fetching;
    },
    error() {
      return this.PublicScheduledDateSchedules.error || this.PublicScheduledDates.error;
    },
    gender() {
      return get(this.PersonalProfile, 'data.gender', 'male') || 'male';
    },
  },
  methods: {
    fetchScheduledDates() {
      this.$store.dispatch('GetPublicScheduledDates', { token: this.token });
    },
    fetchScheduleDetails() {
      this.$store.dispatch('GetPublicScheduleDetails', { id: this.scheduleID, query: { token: this.token, ref_id: this.childScheduleID } });
    },
    fetchScheduledDateSchedules() {
      this.$store.dispatch('GetPublicScheduledDateSchedules', { token: this.token, date: moment(this.scheduleDate).format('YYYY-MM-DD') });
    },
    toggleSidebar() {
      this.$refs.mobileLayout.toggleSidebar();
    },
    onChangeScheduleID(scheduleID, childScheduleID) {
      this.scheduleID = scheduleID;
      this.childScheduleID = childScheduleID;
      this.fetchScheduleDetails();
    },
    onChangeScheduleDate(date) {
      this.scheduleID = null;
      this.scheduleDate = date;
      this.fetchScheduledDateSchedules();
    },
  },
  created() {
    this.scheduleID = this.schedule_id;
    this.childScheduleID = this.child_schedule_id;
    this.scheduleDate = this.schedule_date ? moment(this.schedule_date).toDate() : new Date();

    this.fetchScheduledDates();
    this.fetchScheduledDateSchedules();

    if (this.scheduleID) this.fetchScheduleDetails();
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalScheduledDates');
    this.$store.dispatch('ClearPublicScheduledDateSchedules');
    this.$store.dispatch('ClearPublicScheduleDetails');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/public/schedules/page-participant-public-schedules.vue